var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7206 15.2118L12.7189 15.2147C12.4317 15.6723 12.1964 16.1214 12.0152 16.5618C11.4694 15.229 10.4305 13.8205 8.8623 12.6441C8.20933 12.1516 7.53757 11.7589 6.85552 11.4783C8.51601 10.8088 10.0531 9.60074 11.1106 8.06691C11.4825 7.52959 11.7853 6.9878 12.0128 6.43246C12.6337 7.95297 13.8483 9.4305 15.3407 10.4867C15.9219 10.9001 16.524 11.2367 17.1432 11.4878C15.4048 12.2234 13.6775 13.7018 12.7206 15.2118Z",
    stroke: "#E5E5E5",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30682 6.44722L5.30682 6.44722L5.30563 6.4491C5.19179 6.63054 5.09247 6.81014 5.00835 6.9878C4.68992 6.31467 4.1472 5.62355 3.36827 5.03922C3.07595 4.81875 2.77581 4.63411 2.47037 4.48956C3.3029 4.10916 4.06382 3.484 4.60019 2.70606C4.75883 2.47687 4.89499 2.24545 5.00676 2.00949C5.36867 2.77499 5.99325 3.50201 6.74322 4.03278C6.9987 4.21452 7.26218 4.36956 7.53252 4.4952C6.64656 4.92226 5.79499 5.67683 5.30682 6.44722Z",
    stroke: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.2342db86315c3f8e38d4f5bc04820760.svg";
export { ForwardRef as ReactComponent };